import { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { beginLogin, isAuthenticated } from '../auth/auth';
import { configReady } from '../config';
import { ErrorBanner, toMessage } from '../components/common';
import { PublicBrand } from '../components/PublicBrand';

interface LocationState {
  returnTo?: string;
}

// Redirects to the Cognito hosted UI. Rendered as a small landing card in case
// the redirect is slow or configuration is missing.
export function SignIn() {
  const location = useLocation();
  const returnTo = (location.state as LocationState | null)?.returnTo || '/jobs';
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const ready = configReady();

  useEffect(() => {
    if (ready && isAuthenticated()) return;
    // Auto-start sign-in once on mount when config is present.
    if (ready) start();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function start() {
    setBusy(true);
    setError(null);
    try {
      await beginLogin(returnTo);
    } catch (err) {
      setError(toMessage(err));
      setBusy(false);
    }
  }

  if (isAuthenticated()) {
    return <Navigate to={returnTo} replace />;
  }

  return (
    <div className="public-wrap">
      <div className="card public-card">
        <PublicBrand />
        <p className="muted">Staff sign-in.</p>
        {!ready ? (
          <div className="notice">
            Runtime configuration has not been set. The deploy step writes the Cognito client id and
            domain into config.js. Contact your administrator if this persists.
          </div>
        ) : null}
        {error ? <ErrorBanner message={error} /> : null}
        <div className="btn-row" style={{ marginTop: '1rem' }}>
          <button onClick={start} disabled={busy || !ready}>
            {busy ? 'Redirecting.' : 'Sign in'}
          </button>
        </div>
      </div>
    </div>
  );
}
